import Component from '../Component';
import $ from '../../vendor/CustomJquery';

export default class Login extends Component {

  configure() {
    return super.configure();
  }

  initialize() {
    this.subscribeToEvents();
    return super.initialize();
  }

  subscribeToEvents() {
    this.App.Events.subscribe('loginForm.onOpen', (event) => {
      return this.onOpen(event);
    });
  }

  onOpen(event) {
    this.logger('Open modal with login form');
    let email = event.origin.closest('form').find('[type=email]').val();
    event.modal.find('form [type=email]').val(email).focus();
  }

}